import { jsx as i, jsxs as f } from "react/jsx-runtime";
import { onRoleButtonKeyDown as b } from "../../utils.js";
import { forwardRef as u, useContext as v } from "react";
import { ExpandableContext as h } from "./expandable-context.js";
import { Chevron as T } from "../../chevron/chevron.js";
import e from "../expandable.module.css.js";
import g from "clsx";
const B = u(
  function({ children: m, className: d, disabled: a, onClick: o, as: s = "div", ...n }, l) {
    const { open: t, setOpen: r, contentId: p, titleId: x } = v(h);
    return /* @__PURE__ */ i(s, { className: e.tag, children: /* @__PURE__ */ f(
      "div",
      {
        ...n,
        "aria-controls": p,
        "aria-disabled": a || void 0,
        "aria-expanded": t,
        className: g(e.button, d),
        id: n.id || x,
        onKeyDown: b,
        onClick: (c) => {
          r == null || r(!t), o == null || o(c);
        },
        ref: l,
        role: "button",
        tabIndex: a ? -1 : 0,
        children: [
          m,
          /* @__PURE__ */ i(T, { className: e.chevron, open: t })
        ]
      }
    ) });
  }
);
export {
  B as ExpandableTitle
};
//# sourceMappingURL=expandable-title.js.map
